module.exports = __webpack_public_path__ + "img/error-icon.96f62533.png";